// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
// import { Link } from 'react-router-dom'
import { localize } from 'i18n-calypso'

// Internal Dependencies:
import Editable from 'church-theme-library/components/Editable/Editable'
import Image from 'church-theme-library/components/Image/Image'
import ImageOverlay from 'church-theme-library/components/Image/ImageOverlay'

class SocialLinks extends React.Component {
	render() {
		const { translate, contentId, sectionId, data, facebookURL, youtubeURL } = this.props

		const imageData = data.image || {
			url: '',
			alt: '',
			aspect_ratio: '',
			focal_point: '',
			copy_space: '',
			width: '',
			height: '',
			thumb: '',
			srcset: '',
			type: ''
		}

		return (
			<div className="section-social-links">
				<ImageOverlay imageData={ imageData } />

				<Editable
					id={ contentId }
					sectionId={ sectionId }
					sectionType={ data.type }
					sectionDataId="image"
					className="-image"
				>
					<Image
						thumb={ imageData.thumb }
						thumbWebp={ imageData.thumb_webp }
						url={ imageData.url }
						srcset={ imageData.srcset }
						srcsetWebp={ imageData.srcset_webp }
						sizes={ `(max-width: ${siteData.mobile_max_width}px) 100vw, 1100px` }
						alt={ imageData.alt }
						focalPoint={ imageData.focal_point }
						width={ imageData.width }
						height={ imageData.height }
					/>
				</Editable>

				<div className="-inner">
					<div className="-content">
						<div className="-heading">
							<Editable
								element="h2"
								id={ contentId }
								sectionId={ sectionId }
								sectionType={ data.type }
								sectionDataId="heading"
								content={ data.heading }
							/>
						</div>

						{ ( facebookURL || youtubeURL ) &&
							<div className="-social">
								{ facebookURL &&
									<a className="-social-facebook" href={ facebookURL } target="_blank" rel="noopener">
										<i className="icon-facebook" aria-hidden="true"></i>
										<span className="u-screen-reader-text">Facebook</span>
									</a>
								}

								{ youtubeURL &&
									<a className="-social-youtube" href={ youtubeURL } target="_blank" rel="noopener">
										<i className="icon-youtube-play" aria-hidden="true"></i>
										<span className="u-screen-reader-text">YouTube</span>
									</a>
								}
							</div>
						}
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		facebookURL: state.site.facebookURL,
		youtubeURL: state.site.youtubeURL
	}
}

export default localize(
	connect( mapStateToProps )( SocialLinks )
)
